// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"069446a8","administration":"eb0c4821"}[chunkId] + ".chunk.js";
};